import { RouteRecordRaw } from 'vue-router';
import Home from '@/views/home/index.vue';

const publicRoutes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/lucky-numbers',
    name: 'LuckyNumbers',
    component: () => import('@/views/ticket/LuckyNumbers.vue'),
    props:true
  },
  {
    path: '/results',
    name: 'Results',
    component: () => import('@/views/results/index.vue')
  },
  {
    path: '/wagers',
    name: 'Wagers',
    component: () => import('@/views/wager/index.vue')
  },
  {
    path: '/how-to-play',
    name: 'HowToPlays',
    component: () => import('@/views/how-to-play/index.vue')
  },
  {
    path: '/terms-conditions',
    name: 'TermsAndConditions',
    component: () => import('@/views/terms-conditions/index.vue')
  },
  {
    path: '/retail',
    meta: { isHideHeader: true },
    name: 'Retail',
    component: () => import('@/views/retail/index.vue')
  },
  {
    path: '/test-print',
    name: 'TestPrint',
    component: () => import('@/views/Test-Print/TestPrint.vue')
  }
];

export default publicRoutes;
